import * as React from 'react';
import { IconMapMetroMsk16, IconMapMetroSpb16 } from '@cian/ui-kit-design-tokens/icons';
import { isMoscowOrMO, isSpbOrLO } from '../../../../utils/region';
import * as styles from './UndergroundIcon.css';

interface IUndergroundIconProps {
  regionId: number | null;
  lineColor: string;
}

export const UndergroundIcon: React.FC<IUndergroundIconProps> = props => {
  const { regionId, lineColor } = props;

  if (regionId) {
    let Icon;

    if (isMoscowOrMO(regionId)) {
      Icon = IconMapMetroMsk16;
    }

    if (isSpbOrLO(regionId)) {
      Icon = IconMapMetroSpb16;
    }

    if (Icon) {
      return (
        <div className={styles['underground-icon']} style={{ color: `#${lineColor}` }}>
          <Icon color={'current_color'} />
        </div>
      );
    }
  }

  return <div className={styles['underground-icon--regions']} style={{ color: `#${lineColor}` }} />;
};
